// Import Swiper and modules
import Swiper, { Pagination, Navigation } from 'swiper';
import Helper from '../../../../common/utils/helper';

// Import Swiper styles
import 'swiper/css';

class Group {
    private modalElement: HTMLElement;

    constructor() {
        this.modalElement = document.getElementById('modalTestimonials');
        this.init();
    }

    init() {
        this.resetModalOnOpen();
        this.initPopInButton();
        Group.initSpontaneous();
        Group.initTestimonialsSlider();
    }

    resetModalOnOpen() {
        this.modalElement.addEventListener('hidden.bs.modal', () => {
            this.modalElement.querySelector('.modal-content').innerHTML = '';
        });
    }

    initPopInButton() {
        document.querySelectorAll('.popin-button').forEach((button) => {
            button.addEventListener('click', (e) => this.getTestimonial(e.target as HTMLElement));
        });
    }

    getTestimonial(element: HTMLElement) {
        const url = element.getAttribute('data-url');
        // On va chercher notre témoignage
        fetch(url, {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                this.modalElement.querySelector('.modal-content').innerHTML = data;
            });
    }

    static initSpontaneous() {
        document.querySelector('.send_spontaneous').addEventListener('click', (e) => {
            e.preventDefault();
            const select = document.querySelector('.job-select') as HTMLSelectElement;
            window.open(select.value, '_blank').focus();
        });
    }

    static initTestimonialsSlider() {
        (() => new Swiper('.mySwiper', {
            slidesPerView: 1.25,
            spaceBetween: 10,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 1.75,
                    spaceBetween: 30,
                },
                1400: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
            },
            // configure Swiper to use modules
            modules: [Pagination, Navigation],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        }))();
    }
}

// On document ready
document.addEventListener('DOMContentLoaded', () => {
    (() => new Group())();
});
